import fetch from 'utils/fetch';

export const REQUEST_TIPS = 'REQUEST_TIPS';
export const RECEIVE_TIPS = 'RECEIVE_TIPS';

function requestTips() {
  return {
    type: REQUEST_TIPS,
  };
}

function receiveTips(tips) {
  return {
    type: RECEIVE_TIPS,
    payload: {
      tips,
    },
  };
}

export function fetchTips() {
  return dispatch => {
    dispatch(requestTips());
    fetch('/tips.json')
      .then(res => res.json())
      .then(tips => dispatch(receiveTips(tips)));
  };
}



// WEBPACK FOOTER //
// ./src/modules/catalog/actions/tip.js